module.exports = __webpack_public_path__ + "static/media/baseline-home.b1a41078.svg";